
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region-list-summary/[code]",
      function () {
        return require("private-next-pages/region-list-summary/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region-list-summary/[code]"])
      });
    }
  